import { gql } from '~src/generated/portal/gql';

export const deviceSubscription = gql(`
  subscription DeviceSubscription($projectId: String!) {
    deviceUpdated {
      device(projectId: $projectId) {
        __typename
        id
        underTest
        lastUsed
        status
        testStatus {
          __typename
          test {
            __typename
            id
            cacheId
          }
        }
        user {
          __typename
          id
          profileName
          firstName
          lastName
        }
      }
    }
  }
`);
